<template>
  <Drawer
    width="1000"
    :title="`${openRecipe ? '编辑' : '新增'}配方`"
    v-model="drawerOpened"
  >
    <div class="drawer-content">
      <Form
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
        class="info-panel"
      >
        <FormItem label="销售项目">
          <div class="title">{{ openedSales && openedSales.name }}</div>
        </FormItem>
        <FormItem label="客户">
          <div class="title">
            {{ openedSales.customer && openedSales.customer.name }}
          </div>
        </FormItem>
        <FormItem label="产品">
          <div class="title">
            {{ openedSales.material && openedSales.material.name }}
          </div>
        </FormItem>

        <FormItem label="设为生产配方" prop="usedInProd">
          <i-switch v-model="formItem.usedInProd" size="large">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input
            v-model="formItem.remark"
            placeholder="输入备注..."
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }"
          />
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            @click="handleSubmit('formItem')"
            style="width: 170px"
            >保存</Button
          >
          <Button @click="drawerOpened = false" style="margin-left: 8px"
            >取消</Button
          >
        </FormItem>
      </Form>

      <div class="recipe-panel">
        <Table
          :columns="columns"
          :data="displayData"
          border
          show-summary
          :summary-method="handleSummary"
        >
          <template slot-scope="{ row, index }" slot="ratio">
            <div v-if="row.name !== '水'">
              <InputNumber
                :max="100"
                :min="0"
                :step="0.1"
                v-model="recipeList[index].ratio"
                class="input-ratio"
              />
              <span class="percentage-append">%</span>
            </div>
            <span v-else>{{ row.ratio }}%</span>
          </template>

          <template
            slot-scope="{ row }"
            slot="deleteBtn"
            style="padding-left: 0"
          >
            <Icon
              v-if="row.name !== '水'"
              type="ios-remove-circle-outline"
              class="deleteBtn"
              @click="removeMaterialfromRecipe(row._id)"
            />
          </template>
        </Table>
      </div>

      <div class="material-panel">
        <Input
          search
          clearable
          placeholder="搜索原材料..."
          style="margin: 0 4px"
          v-model="searchMaterialText"
          @on-search="searchMaterial"
        />
        <Divider orientation="left">母液</Divider>
        <div class="material-list">
          <div
            @click="addToRecipe(i)"
            v-for="(i, index) in materialList.filter((x) => x.type === 'semi')"
            :key="index"
            :class="{
              'm-cell': true,
              selected: displayData.map((e) => e._id).indexOf(i._id) !== -1,
            }"
          >
            {{ i.name }}
          </div>
        </div>
        <Divider orientation="left">原材料</Divider>
        <div class="material-list">
          <div
            @click="addToRecipe(i)"
            v-for="(i, index) in materialList.filter(
              (x) => x.type === 'raw' && x.usedForProduct === true
            )"
            :key="index"
            :class="{
              'm-cell': true,
              selected: displayData.map((e) => e._id).indexOf(i._id) !== -1,
            }"
          >
            {{ i.name }}
          </div>
        </div>
      </div>
    </div>
  </Drawer>
</template>

<script>
import dayjs from "dayjs";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      drawerOpened: false,
      recipeList: [],
      searchMaterialText: null,
      cusSelectType: "搜索客户",
      openedSales: {},
      openRecipe: null,
      formItem: {
        name: null,
        usedInProd: true,
        remark: null,
      },
      ruleValidate: {},
      materialList: [],
      water: null,
      columns: [
        {
          title: "原材料",
          key: "name",
        },
        {
          title: "比例",
          key: "ratio",
          slot: "ratio",
          align: "right",
          width: 130,
        },
        {
          title: " ",
          key: "deleteBtn",
          slot: "deleteBtn",
          align: "left",
          width: 40,
        },
      ],
    };
  },
  computed: {
    sumRatio: function () {
      return this.recipeList.reduce((sum, row) => sum + (row.ratio || 0), 0);
    },
    displayData: function () {
      if (this.water) {
        this.water.ratio = (100 - this.sumRatio).toFixed(2);
        return [...this.recipeList, this.water];
      } else {
        return [...this.recipeList];
      }
    },
    ...mapState({
      salesList: (state) => state.sac.sac.sales,
    }),
  },
  sockets: {},
  methods: {
    async searchMaterial() {
      this.materialList = await this.getMaterials({
        searchText: this.searchMaterialText,
        usedForProduct: true,
      });
    },
    ...mapActions({
      updateSalesOne: "sac/updateSacSalesAction",
      updateRecipe: "sac/updateSacRecipeAction",
      createRecipe: "sac/createSacRecipeAction",
      getMaterials: "material/getMaterialsAction",
    }),
    async openDrawer(salesId, recipe) {
      this.recipeList = [];
      this.openRecipe = null;
      this.$refs["formItem"].resetFields();
      if (!salesId) return this.$Message.error(`请先选择销售项目`);
      this.drawerOpened = true;
      try {
        this.openedSales = this.salesList.find((x) => x._id === salesId);
      } catch (error) {
        this.$Message.error(`获取产品失败: ${error}`);
      }
      if (recipe) {
        this.openRecipe = recipe;
        this.openedSales.prodRecipe &&
        this.openedSales.prodRecipe.toString() === recipe._id.toString()
          ? (this.formItem.usedInProd = true)
          : (this.formItem.usedInProd = false);
        this.formItem.name = recipe.name;
        this.formItem.remark = recipe.remark;
        recipe.detail.map((x) => {
          if (x.material.name !== "水") {
            this.recipeList.push({
              name: x.material.name,
              _id: x.material._id,
              ratio: x.ratio * 100,
            });
          } else {
            this.water = {
              name: x.material.name,
              _id: x.material._id,
              ratio: x.ratio * 100,
            };
          }
        });
      } else {
        this.water = {
          ...this.materialList.find((x) => x.name === "水"),
          ratio: 100,
        };
      }
    },
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          if (this.water.ratio < 0) {
            return this.$Message.warning("材料总和不能超过100%");
          }
          let newRecipe;
          let newSales;
          try {
            // 判断是否编辑
            if (this.openRecipe) {
              // 更新配方
              newRecipe = await this.updateRecipe({
                id: this.openRecipe._id,
                data: {
                  ...this.formItem,
                  sales: this.openedSales._id,
                  detail: this.displayData.map((e) => {
                    return {
                      material: e._id,
                      ratio: e.ratio * 0.01,
                    };
                  }),
                },
              });
              let newSalesData;
              if (this.formItem.usedInProd) {
                newSalesData = {
                  prodRecipe: newRecipe._id,
                };
              } else {
                newSalesData = {
                  prodRecipe: null,
                };
              }
              newSales = await this.updateSalesOne({
                id: this.openedSales._id,
                data: newSalesData,
              });
            } else {
              // 创建配方
              this.formItem.name = dayjs().format("YYYY年MM月DD日HH时");
              newRecipe = await this.createRecipe({
                ...this.formItem,
                sales: this.openedSales._id,
                detail: this.displayData.map((e) => {
                  return {
                    material: e._id,
                    ratio: e.ratio * 0.01,
                  };
                }),
              });
              if (this.formItem.usedInProd) {
                newSales = await this.updateSalesOne({
                  id: this.openedSales._id,
                  data: {
                    prodRecipe: newRecipe._id,
                  },
                });
              }
            }
            this.$Message.success("保存成功!");
            this.drawerOpened = false;
            this.recipeList = [];
            this.$emit(
              "updatedGetRecipe",
              newSales ? newSales : this.openedSales
            );
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
    addToRecipe(m) {
      this.recipeList.unshift({ ...m, ratio: 0 });
    },
    removeMaterialfromRecipe(id) {
      this.recipeList = this.recipeList.filter((e) => e._id != id);
    },
    handleSummary({ columns, data }) {
      return {
        name: {
          key: "name",
          value: "总和",
        },
        ratio: {
          key: "ratio",
          value: 100 + "%",
        },
        deleteBtn: {
          key: "deleteBtn",
          value: null,
        },
      };
    },
  },
  async mounted() {
    this.materialList = await this.getMaterials({});
  },
};
</script>

<style scoped lang="stylus">
.drawer-content
  display flex
  height 100%

.info-panel
  width 250px
  height 100%
  overflow-y auto

// 配方表格
.recipe-panel
  padding 0 8px
  max-height 100%
  width 400px

.deleteBtn
  cursor pointer

  &:hover
    color red

.input-ratio
  width 75px
  float left
  text-align right
  margin-right 4px

.percentage-append
  float right
  line-height 32px
  height 32px

.sum-ratio
  line-height 32px
  font-weight 500
  font-size 20px
  margin-right 4px

// 材料列表
.material-panel
  overflow-y auto
  padding 0 16px 0 16px
  height 100%
  width 318px

.material-list
  display flex
  flex-wrap wrap
  align-content flex-start
  margin-top 8px

.m-cell
  padding 8px
  margin 4px
  border 1px solid lightgray
  border-radius 4px
  cursor pointer

  &:hover
    color #0168FA
    border 1px solid #0168FA
    box-shadow 0 2px 4px rgba(209, 230, 250, 1)
    transition 0.2s

.selected
  color lightgray
  cursor default
  pointer-events none

.title
  font-size 16px
</style>
